import { Base64ImageStorage, extractImgSrc } from '../storage/Base64ImageStorage';

/**
 * Base64Image id of the PDF action icon, shared by the Clients report columns (ProfileRowEditor)
 * and the ReportView header. Callers fall back to a 📄 glyph when the image isn't found (e.g.
 * missing on an older/other environment).
 */
export const PDF_ICON_IMAGE_ID = '105';

/** Resolves the PDF icon to a displayable src (data-URI), or null if it isn't in storage. */
export async function loadPdfIconSrc(storage: any): Promise<string | null> {
  if (!storage) {
    return null;
  }
  try {
    const image = await new Base64ImageStorage(storage).getImage(PDF_ICON_IMAGE_ID);
    return (image?.base64 && extractImgSrc(image.base64)) || null;
  } catch (error) {
    console.warn('reportPdfIcon: failed to load PDF icon image', error);
    return null;
  }
}
